import styles from "../Results.module.css";

const DeniedUpsellContent = (): JSX.Element => {
  return (
    <>
      <p className={styles.description} data-testid="denied-upsell">
        Because of the location of your primary business address and the number
        of employees on COBRA, we can’t offer you a quote right now. If your
        business moves, the number of employees on COBRA decreases, or the total
        number of employees increases email us at{" "}
        <a
          className="milo--link"
          target="_blank"
          rel="noreferrer"
          href="mailto: support@justworks.com"
        >
          support@justworks.com
        </a>{" "}
        to update your application.
      </p>

      <p className={styles.description}>
        <a
          className="milo--link"
          target="_blank"
          rel="noreferrer"
          href="https://help.justworks.com/hc/en-us/articles/360046094251-Carrier-Eligibility-Requirements"
        >
          Learn more
        </a>{" "}
        about our carrier eligibility requirements.
      </p>
    </>
  );
};

export default DeniedUpsellContent;
